module.exports = ".cache_modal {\n  opacity: 1;\n  background-color: black; }\n"